import React from 'react';
import styled from 'styled-components';
import { css } from 'emotion';
import SliderModal from './SliderModal';
import DropDown from 'react-dropdown';
import { navigate } from "gatsby";

/*global tw*/

const ModalInner = styled.div`
    ${tw`relative flex flex-wrap items-center px-6 py-4 pb-24 max-h-full w-full overflow-y-scroll`};
    -webkit-overflow-scrolling: touch;
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
`

const ModalHeading = styled.p`
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-size: 1.25rem;
    font-weight: 700;
    color: #F5F5F7;
    padding: 1rem 0;
    letter-spacing: -0.02em;
`

const DropdownWrapper = styled.div`
    ${tw`w-full mt-4`};
    .Dropdown-root { font-family: 'Plus Jakarta Sans', 'Inter', sans-serif; }
    .Dropdown-control {
        background: #111118;
        border: 1px solid rgba(170,11,202,0.25);
        color: #9898A8;
        border-radius: 6px;
        padding: 0.75rem 0.875rem;
        font-size: 0.9375rem;
        cursor: pointer;
        transition: border-color 0.18s ease;
        &:hover { border-color: rgba(170,11,202,0.5); }
    }
    .Dropdown-menu {
        background: #1A1A24;
        border: 1px solid rgba(170,11,202,0.2);
        border-radius: 6px;
        overflow: hidden;
    }
    .Dropdown-option {
        color: #9898A8;
        padding: 0.5rem 0.875rem;
        font-size: 0.9375rem;
        transition: background 0.15s ease;
        &:hover { background: rgba(170,11,202,0.1); color: #F5F5F7; }
    }
    .Dropdown-option.is-selected {
        background: rgba(170,11,202,0.12);
        color: #F5F5F7;
    }
    .Dropdown-arrow { border-top-color: #9898A8; }
`

const ButtonRow = styled.div`
    ${tw`w-full my-4 flex lg:justify-end items-center`};
    gap: 0.75rem;
`

const BackBtn = styled.button`
    ${tw`w-full lg:w-1/4 px-4 py-3 mt-4 text-xl cursor-pointer outline-none appearance-none border-none`};
    background: transparent;
    color: #5A5A6E;
    border-radius: 6px;
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-weight: 600;
    font-size: 1rem;
    transition: all 0.18s ease;
    &:hover { background: rgba(255,255,255,0.05); color: #9898A8; }
`

const ProceedBtn = styled.button`
    ${tw`w-full lg:w-1/4 px-4 py-3 mt-4 text-xl cursor-pointer outline-none appearance-none border-none`};
    background: linear-gradient(135deg, #AA0BCA 0%, #5500DB 100%);
    color: #FFFFFF;
    border-radius: 6px;
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-weight: 700;
    font-size: 1rem;
    box-shadow: 0 4px 16px rgba(170,11,202,0.35);
    transition: all 0.2s ease;
    &:hover {
        filter: brightness(1.12);
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(170,11,202,0.4);
    }
    &:active { transform: scale(0.97); }
`

class ZoomLocationSlider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            label: '',
            location: null
        }
    }

    render() {
        return (
            <SliderModal active={this.props.active}>
                <ModalInner>
                    <ModalHeading>Select Vehicle Pickup &amp; Dropoff address</ModalHeading>
                    <DropdownWrapper>
                        <DropDown
                            options={this.props.locations}
                            value={this.state.label}
                            onChange={(event) => {
                                this.setState({ location: event, label: event.label })
                            }}
                            placeholder="Pickup Location"
                        />
                    </DropdownWrapper>
                    <ButtonRow>
                        <BackBtn onClick={() => { navigate(`/carsList`) }}>Back</BackBtn>
                        <ProceedBtn onClick={() => this.props.handleZoomLocationSelect(this.state.location)}>Proceed</ProceedBtn>
                    </ButtonRow>
                </ModalInner>
            </SliderModal>
        )
    }
}

export default ZoomLocationSlider;
